"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3176],{

/***/ 93176:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ hubspot_with_bullets_side_by_side_form_component; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./segments/desktop/core-components/side-by-side-text-and-asset/side-by-side-text-and-asset.js
var side_by_side_text_and_asset = __webpack_require__(59526);
// EXTERNAL MODULE: ./segments/desktop/core-components/hubspot-contact-form/hubspot-contact-form.js + 4 modules
var hubspot_contact_form = __webpack_require__(58625);
// EXTERNAL MODULE: ./segments/desktop/core-components/title/title.js + 1 modules
var title_title = __webpack_require__(91265);
// EXTERNAL MODULE: ./constants/sizes.js
var sizes = __webpack_require__(77869);
// EXTERNAL MODULE: ./contexts/generic-config-context.js
var generic_config_context = __webpack_require__(3156);
// EXTERNAL MODULE: ./client/services/hubspot-service/contact-form-config.js + 1 modules
var contact_form_config = __webpack_require__(49228);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./segments/desktop/form/layouts/hubspot-with-bullets-side-by-side-form/contact-sales-details.js
var contact_sales_details = __webpack_require__(43848);
// EXTERNAL MODULE: ./segments/desktop/core-components/hubspot-contact-form/default-props.js
var default_props = __webpack_require__(95472);
// EXTERNAL MODULE: ./segments/desktop/core-components/logos/logos-const.js
var logos_const = __webpack_require__(83971);
;// CONCATENATED MODULE: ./segments/desktop/form/layouts/hubspot-with-bullets-side-by-side-form/default-props.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



/* harmony default export */ var hubspot_with_bullets_side_by_side_form_default_props = (_object_spread_props(_object_spread({}, default_props/* default */.Z), {
    backgroundLayers: 3,
    title: "Contact sales to see why monday is the new way of working",
    titleSize: sizes.MD,
    benefits: [
        {
            title: "Across <b>190+</b> countries",
            description: "Meet with a product consultant to see how monday.com can fit your exact business needs",
            icon: "/static/img/contact-sales/countries_icon.png"
        },
        {
            title: "<b>152k+</b> paying customers",
            description: "Explore our tailored pricing plans based on your goals and priorities",
            icon: "/static/img/contact-sales/customers_icon.png"
        },
        {
            title: "Serving <b>200+</b> industries",
            description: "Boost productivity from day one by building your team's ideal workflow",
            icon: "/static/img/contact-sales/industries_icon.png"
        }
    ],
    hideSupportStatement: false,
    hideLogos: false,
    logosTitle: {
        title: "<monday-bold>Trusted by top companies and brands</monday-bold>",
        titleSize: sizes/* XS_M */.g4,
        textAlign: "left"
    },
    logos: {
        numberOfCompanies: 5,
        companyField: logos_const/* LOGO_COMPANY_FIELDS.ENTERPRISE */.QS.ENTERPRISE
    },
    paddingBottom: "32px"
}));

// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
;// CONCATENATED MODULE: ./segments/desktop/form/layouts/hubspot-with-bullets-side-by-side-form/hubspot-with-bullets-side-by-side-form-component.scss.js




var StyledHubspotWithBulletsSideBySideFormComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ey0q9ax0"
})("max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px;margin:auto;.mobile-title{display:none;padding:0 20px;.core-title-container .core-title{font-size:1.125rem;line-height:32px;}}&:not(.align-to-logo){.contact-sales-details{@media (min-width:", vp_sizes/* TABLET_QUERY_MAX_WIDTH */.y, "){padding-left:60px;}}}.contact-sales-title{.core-title-container .core-title{font-weight:bold;}}.benefits-wrapper{.benefit-wrapper{margin-top:16px;display:flex;align-items:center;&:first-of-type{margin-top:32px;}.benefit-icon-wrapper{display:flex;flex-direction:column;align-items:center;width:120px;flex-shrink:0;.icon-text{margin-top:4px;font-size:0.8125rem;text-align:center;color:", colors/* default.asphalt */.Z.asphalt, ";}}.benefit-text-divider{height:78px;width:5px;border:0;border-right:1px solid;border-color:", colors/* default.wolf */.Z.wolf, ";}.benefit-text-wrapper{font-size:0.875rem;flex-grow:1;margin-left:24px;line-height:24px;padding-right:48px;}}}.support-paragraph-wrapper{padding:32px 0;.support-paragraph-text{font-size:0.8125rem;.support-paragraph-link{color:", colors/* default.brand-blue */.Z["brand-blue"], ";&:hover{filter:brightness(85%);}&:visited,a:hover,a:active{color:", colors/* default.brand-blue */.Z["brand-blue"], ";}}}}.customer-quote-wrapper{background-color:", colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME], ";border-radius:8px;padding:24px 32px;margin-bottom:32px;.quote{position:relative;margin:auto 0;display:flex;text-align:left;letter-spacing:-0.5px;line-height:30px;font-size:1.125rem;.quotationMark{position:absolute;top:0;left:-12px;margin-right:8px;}}.name-and-job-description{margin-top:32px;font-size:0.8125rem;font-weight:400;line-height:20px;}}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH */.zD, "){.mobile-title{display:block;margin:16px auto;text-align:center;font-weight:bold;}.contact-sales-details{padding-left:0;.contact-sales-title{display:none;}}.benefits-wrapper{.benefit-wrapper{flex-direction:column;&:first-child{margin-top:0;}.benefit-text-divider{height:0;width:78px;border-top:1px solid;border-color:", colors/* default.wolf */.Z.wolf, ";}.benefit-text-wrapper{padding-right:0;margin:0 16px;text-align:center;}}}.support-paragraph-wrapper{text-align:center;}.images-gallery-row{justify-content:center !important;}}");

;// CONCATENATED MODULE: ./segments/desktop/form/layouts/hubspot-with-bullets-side-by-side-form/hubspot-with-bullets-side-by-side-form-component.js
function hubspot_with_bullets_side_by_side_form_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function hubspot_with_bullets_side_by_side_form_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            hubspot_with_bullets_side_by_side_form_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}











var isProduction = "production" === "production";
var HubspotWithBulletsSideBySideFormComponent = function(props) {
    var translate = props.translate;
    var formId = props.formId, source = props.source, overrideCampaignId = props.overrideCampaignId, lastNameFirst = props.lastNameFirst, backgroundLayers = props.backgroundLayers, title = props.title, titleSize = props.titleSize, benefits = props.benefits, logosTitle = props.logosTitle, logos = props.logos, customerQuoteKey = props.customerQuoteKey, formTitle = props.formTitle, hideSupportStatement = props.hideSupportStatement, hideLogos = props.hideLogos, contactSalesTestMode = props.contactSalesTestMode, alignToLogo = props.alignToLogo, urlToRedirectAfterSubmission = props.urlToRedirectAfterSubmission, dontRenderPostFormSubmit = props.dontRenderPostFormSubmit, splitForm = props.splitForm, simulateBookAMeetingEmailTest = props.simulateBookAMeetingEmailTest, restProps = _object_without_properties(props, [
        "formId",
        "source",
        "overrideCampaignId",
        "lastNameFirst",
        "backgroundLayers",
        "title",
        "titleSize",
        "benefits",
        "logosTitle",
        "logos",
        "customerQuoteKey",
        "formTitle",
        "hideSupportStatement",
        "hideLogos",
        "contactSalesTestMode",
        "alignToLogo",
        "urlToRedirectAfterSubmission",
        "dontRenderPostFormSubmit",
        "splitForm",
        "simulateBookAMeetingEmailTest"
    ]);
    var componentPortalId = contact_form_config/* PORTAL_ID */.Im;
    var componentFormId = formId;
    if (!isProduction || contactSalesTestMode) {
        componentPortalId = contact_form_config/* TEST_PORTAL_ID */.ND;
        componentFormId = contact_form_config/* TEST_CONTACT_SALES_HUBSPOT_FORM_ID */.aC;
    }
    var replaceTextComponentProps = {
        portalId: componentPortalId,
        formId: componentFormId,
        source: source,
        overrideCampaignId: overrideCampaignId,
        lastNameFirst: lastNameFirst,
        backgroundLayers: backgroundLayers,
        formTitle: formTitle,
        urlToRedirectAfterSubmission: urlToRedirectAfterSubmission,
        dontRenderPostFormSubmit: dontRenderPostFormSubmit,
        splitForm: splitForm,
        simulateBookAMeetingEmailTest: simulateBookAMeetingEmailTest
    };
    var replaceAssetComponentProps = {
        title: title,
        titleSize: titleSize,
        benefits: benefits,
        logosTitle: logosTitle,
        logos: logos,
        customerQuoteKey: customerQuoteKey,
        hideSupportStatement: hideSupportStatement,
        hideLogos: hideLogos
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHubspotWithBulletsSideBySideFormComponent, {
        className: classnames_default()("hubspot-with-bullets-side-by-side-form-component", {
            "align-to-logo": alignToLogo
        }),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mobile-title",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(title_title/* default */.Z, {
                    title: translate(title),
                    titleSize: sizes.MD
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(side_by_side_text_and_asset/* default */.Z, hubspot_with_bullets_side_by_side_form_component_object_spread({
                replaceTextComponent: hubspot_contact_form/* default */.Z,
                replaceAssetComponent: contact_sales_details/* default */.Z,
                replaceTextComponentProps: replaceTextComponentProps,
                replaceAssetComponentProps: replaceAssetComponentProps,
                alignToLogo: alignToLogo
            }, restProps))
        ]
    });
};
HubspotWithBulletsSideBySideFormComponent.defaultProps = hubspot_with_bullets_side_by_side_form_default_props;
/* harmony default export */ var hubspot_with_bullets_side_by_side_form_component = ((0,generic_config_context/* withGenericConfig */.P)(HubspotWithBulletsSideBySideFormComponent));


/***/ })

}]);